<template>
  <panel content="想知道您的产品市场买账吗？"
         :url="url"> </panel>
</template>

<script>
import panel from './panel-1'
export default {
  components: {
    panel,
  },
  data () {
    return {
      url: require('@/assets/access_images/access-email.png')
    }
  },
}
</script>

<style lang="scss" scoped>
</style>